export const placeholders = {
  email: 'email@mail.com',
  phone: '+1 (212) 000-0000',
};
